export default {
  groupName: 'retail',
  appName: 'Retail Syndicated Ad Effect Tracker',
  baseRoute: '/dashboard/retail',
  label: 'Retail Syndicated Ad Effect Tracker',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Retail Syndicated Ad Effect Tracker'
};



// WEBPACK FOOTER //
// ./src/app/configuration/Retail/config/main.js